import { isMobile } from '../utils/index'
export default {
  address: '桃園市桃園區新埔六街97號16樓',
  googleSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.5699101093123!2d121.29992931500591!3d25.014726283981375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34681fb1f2d86179%3A0x727c09d7f490ef69!2zMzMw5qGD5ZyS5biC5qGD5ZyS5Y2A5paw5Z-U5YWt6KGXOTfomZ8!5e0!3m2!1szh-TW!2stw!4v1607682826270!5m2!1szh-TW!2stw',
  googleLink: 'https://goo.gl/maps/L7dBXU3XqJ8BSCVx7',
  phone: '+886-3-3569188',
  email: 'lichin9188@gmail.com',
  mechanism: '立瑾建築機構',
  fbLink: 'https://www.facebook.com/lichinconstruction',
  fbMessage: 'https://m.me/lichinconstruction',
  caseName: '立瑾建築機構',
  indigatorLength: 10,

  houseInfos: [
  //  ['投資興建', '合康建設股份有限公司'],
   // ['營造公司', '閤康聯合建築師事務所'],
   // ['營造公司', '洛城營造'],
   // ['企劃銷售', '新高創廣告有限公司'],
   //['景觀設計', '六國景觀-蘇瑞泉大師'],
   // ['建照號碼', '108建字第0256號'],
  ],

  gtmCode: ['TWFWBCK'], // 可放置多個
  recaptcha_site_key_v2: '6Lep-78UAAAAAMaZLtddpvpixEb8cqu7v7758gLz',
  recaptcha_site_key: '6Lck-L8UAAAAABxfvNA1NJuBrdl3iLFc3GkudC8s', // recaptcha v3
  recaptcha_user_token: '6Lep-78UAAAAAIDMeDQOBwK-OK3yNooejpZeNCsS',
  order: {
    title: isMobile ? '聯絡我們' : '聯絡我們',
    subTitle: 'Contacts'
  }
}
